import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LayoutModule } from '../layout/layout.module';
import { SharedModule } from './../shared/shared.module';
import { MySwarmListComponent } from './my-swarm-list/my-swarm-list.component';
import { MySwarmSidebarComponent } from './my-swarm-sidebar/my-swarm-sidebar.component';
import { MySwarmComponent } from './my-swarm.component';
import { MySwarmQueryResolve } from './my-swarm.resolve';
import { MySwarmInventoryComponent } from './my-swarm-inventory/my-swarm-inventory.component';

@NgModule({
  imports: [CommonModule, SharedModule, LayoutModule],
  declarations: [MySwarmComponent, MySwarmSidebarComponent, MySwarmListComponent, MySwarmInventoryComponent],
  providers: [MySwarmQueryResolve]
})
export class MySwarmModule {}
